
        var result = require("!!../../../../node_modules/css-loader/index.js!./clothes-admin-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/clothes-admin-list/clothes-admin-list.component.css
// module id = 580
// module chunks = 0